import { render, staticRenderFns } from "./reviews-modal.vue?vue&type=template&id=6a7019b3&scoped=true&"
import script from "./reviews-modal.vue?vue&type=script&lang=js&"
export * from "./reviews-modal.vue?vue&type=script&lang=js&"
import style0 from "./reviews-modal.vue?vue&type=style&index=0&id=6a7019b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7019b3",
  null
  
)

export default component.exports